import React from "react";

// icons
import { AiOutlineMenu, AiFillBell, AiFillMail } from "react-icons/ai";

import styles from "./Header.module.scss";

const Header = ({ toggle }) => {
  return (
    <div className={styles.header}>
      <span className={styles.icon__wrapper} onClick={toggle}>
        <AiOutlineMenu />
      </span>
      <div>
        <span className={styles.icon__wrapper}>
          <AiFillBell />
        </span>
        <span className={styles.icon__wrapper}>
          <AiFillMail />
        </span>
      </div>
    </div>
  );
};

export default Header;
